import { useEffect, useState } from 'react';
import i18n from '../../i18n'
import antd_EN from 'antd/es/locale/en_GB'
import antd_NL from 'antd/es/locale/nl_NL'

// language support for moment
import moment from 'moment'
import 'moment/locale/nl'


const supportedLanguages = [
        {
            name: 'EN', 
            description: 'English',
            antd: antd_EN,
            i18n: 'en',
            moment: 'en-gb',
            api: 'EN'
        }, {
            name: 'NL', 
            description: 'Nederlands',
            antd: antd_NL,
            i18n: 'nl',
            moment: 'nl',
            api: 'NL'
        }
];

export function useLanguage ()
{
    const [currentLanguage, setCurrentLanguage] = useState();

    useEffect(() => {
        setLanguageName();
    // eslint-disable-next-line
    }, [])

    function setLanguageName(languageName) {
        let language = undefined;
        if(languageName === undefined)
        {
            language = initialize();
        }
        else {
            language = getCurrentLanguage(languageName);
            if (language === undefined) {
                console.warn(`unsupported language ${languageName}`);
                return;
            }
        }

        if(language !== undefined) {
            localStorage.setItem("languageName", language.name);
            setNewLanguage(language)
            setCurrentLanguage(language)
        }
    }

    return [currentLanguage, setLanguageName];

    function initialize(){

        if(localStorage.getItem("languageName") === null) {
            return getCurrentLanguage("EN");
        }

        return getCurrentLanguage(localStorage.getItem("languageName"));
    }

    function getCurrentLanguage(languageName)
    {
        return supportedLanguages.find(supportedLanguage => supportedLanguage.name === languageName);
    }

    function setNewLanguage(language)
    {
        moment.locale(language.moment);
        i18n.changeLanguage(language.i18n);
    }
}

